$(document).ready(function(){

    if ($("#whychoose_Slider").length) {
      $("#whychoose_Slider").owlCarousel({
        loop: false,
        autoplay: false,
        autoplayTimeout:4000,
        autoplaySpeed: 1000,
        margin: 30,
        nav: false,
        responsive: {
          0: {
            items: 1,
            stagePadding: 50,
            dots: true,
          },
          767: {
            items: 1,
            dots: false,
          },
          992: {
            items: 3,
            dots: false,
          }
        }
      });
  }

  if ($("#Groom_Review_Slider").length) {
      $("#Groom_Review_Slider").owlCarousel({
        loop: true,
        autoplay: true,
        autoplayTimeout:4000,
        autoplaySpeed: 1000,
        margin: 30,
        nav: true,
        dots: false,
        responsive: {
          0: {
            items: 1,
          },
          767: {
            items: 2
          },
          992: {
            items: 3
          }
        }
      });
  }


  $('.play_motions_video').on('click', function(ev) {
    $("#motion_video").fadeIn();
    $("#motion_video").attr("src", "https://www.youtube.com/embed/EngW7tLk6R8?&showinfo=0&rel=0&autoplay=1")
      ev.preventDefault();
    });

  $(".menuic").click(function() {
    $(this).toggleClass("active");
    $("body").toggleClass("active");
  });

    
  $(".accord_title h3").click(function(){
    if ($(this).parent().hasClass("accordshow")) {
      $(".accord_title").removeClass('accordshow');
      $('.accord_desc').slideUp();
      return false;
    }
    $('.accord_desc').slideUp();
    $(".accord_title").removeClass('accordshow');
    $(this).next().slideDown();
    $(this).parent().addClass('accordshow');
  });

  $(".getintouch_btn").on("click", function (e) {
      e.preventDefault();
      $("html, body").animate({
          scrollTop: $("#getintouch").offset().top - 200
      }, 800); // 800ms animation
  });


}); //end jquery


